import React from 'react'
import injectSheet from 'react-jss'
import style from './style'

/**
 * A sidebar menu that contains routes to different paths, overlays on mobile. NOTE: requires react-router-redux
 */

export const Header = props => {
  let { classes, img, isForMobile } = props
  const { base, content, hideOnDesktop } = classes

  const handleClick = () => {
    const { onClick } = props
    if (onClick) onClick()
  }

  return (
    <div className={`${base} menu-header`}>
      <div
        className={isForMobile ? `${content}` : `${hideOnDesktop} ${content} `}
        onClick={handleClick}
      >
        <img src={img.src} alt="header" />
      </div>
    </div>
  )
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(Header)
